/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Audience_BeginnerInputs */

const en_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginner`)
};

const es_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

const de_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfänger`)
};

const zh_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初学者`)
};

const ar_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مبتدئ`)
};

const fr_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutant`)
};

const vi_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người mới`)
};

const sw_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anayeanza`)
};

const th_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระดับเริ่มต้น`)
};

const bs_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Početnik`)
};

const ja_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初心者`)
};

const ko_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초보자`)
};

const pt_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciante`)
};

const it_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

const sv_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nybörjare`)
};

const nl_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginner`)
};

const da_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begynder`)
};

const nb_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nybegynner`)
};

const fi_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloittelija`)
};

const pl_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Początkujący`)
};

const ru_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинающий`)
};

const tr_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni başlayan`)
};

const hi_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरुआती`)
};

const id_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemula`)
};

const ms_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemula`)
};

const cs_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začátečník`)
};

const el_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αρχάριος`)
};

const he_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתחיל`)
};

const af_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginner`)
};

const hu_method_audience_beginner = /** @type {(inputs: Method_Audience_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezdő`)
};

/**
* | output |
* | --- |
* | "Beginner" |
*
* @param {Method_Audience_BeginnerInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_audience_beginner = /** @type {((inputs?: Method_Audience_BeginnerInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Audience_BeginnerInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_audience_beginner(inputs)
	if (locale === "de") return de_method_audience_beginner(inputs)
	if (locale === "zh") return zh_method_audience_beginner(inputs)
	if (locale === "ar") return ar_method_audience_beginner(inputs)
	if (locale === "fr") return fr_method_audience_beginner(inputs)
	if (locale === "vi") return vi_method_audience_beginner(inputs)
	if (locale === "sw") return sw_method_audience_beginner(inputs)
	if (locale === "th") return th_method_audience_beginner(inputs)
	if (locale === "bs") return bs_method_audience_beginner(inputs)
	if (locale === "ja") return ja_method_audience_beginner(inputs)
	if (locale === "ko") return ko_method_audience_beginner(inputs)
	if (locale === "pt") return pt_method_audience_beginner(inputs)
	if (locale === "it") return it_method_audience_beginner(inputs)
	if (locale === "sv") return sv_method_audience_beginner(inputs)
	if (locale === "nl") return nl_method_audience_beginner(inputs)
	if (locale === "da") return da_method_audience_beginner(inputs)
	if (locale === "nb") return nb_method_audience_beginner(inputs)
	if (locale === "fi") return fi_method_audience_beginner(inputs)
	if (locale === "pl") return pl_method_audience_beginner(inputs)
	if (locale === "ru") return ru_method_audience_beginner(inputs)
	if (locale === "tr") return tr_method_audience_beginner(inputs)
	if (locale === "hi") return hi_method_audience_beginner(inputs)
	if (locale === "id") return id_method_audience_beginner(inputs)
	if (locale === "ms") return ms_method_audience_beginner(inputs)
	if (locale === "cs") return cs_method_audience_beginner(inputs)
	if (locale === "el") return el_method_audience_beginner(inputs)
	if (locale === "he") return he_method_audience_beginner(inputs)
	if (locale === "af") return af_method_audience_beginner(inputs)
	if (locale === "hu") return hu_method_audience_beginner(inputs)
	return en_method_audience_beginner(inputs)
});